import { type ReactNode } from 'react'
import { FlatCardsContext } from '@/components/Card'
import styles from './CardBand.module.css'

export interface CardBandProps {
  children: ReactNode
}

/**
 * Lays out stage cards flat, in the same band as the job's step line.
 */
export function CardBand({ children }: CardBandProps) {
  return (
    <FlatCardsContext.Provider value>
      <div className={styles.root}>{children}</div>
    </FlatCardsContext.Provider>
  )
}
